import React from 'react'
import SecondarySectionLayout from '../layout/SecondarySectionLayout'
import ImageWrapper from '../common/ImageWrapper'
import { graphql, useStaticQuery } from 'gatsby'

const SuccessGuarantee = () => {

    const data = useStaticQuery(query);

    const { allStrapiHomeSuccessGuarantee: { nodes: HomeSuccessGuarantee } } = data;

    const { home_successGuarantee_heading, home_successGuarantee_cards } = HomeSuccessGuarantee[0];

  return (
      <>
          <SecondarySectionLayout SecondarySectionAltHeading={home_successGuarantee_heading}>
              <div className="success_guarantee_first">
                  {home_successGuarantee_cards.map((items) => (
                      <div className="success_guarantee_item" key={items.id}>
                          <ImageWrapper ImgUrl={items.card_wrapper_type_one_image.url} />
                          <p>{items.card_wrapper_type_one_description}</p>
                      </div>
                ))}
        </div>
          </SecondarySectionLayout>
    </>
  )
}

const query = graphql`
{
  allStrapiHomeSuccessGuarantee {
    nodes {
      home_successGuarantee_heading
      home_successGuarantee_cards {
        id
        card_wrapper_type_one_image {
          url
        }
        card_wrapper_type_one_description
      }
    }
  }
}
`

export default SuccessGuarantee